import * as THREE from 'three'
import { loadMeshes, loadTexturedMaterials } from '../helpers/ThreeLoaderHelper';
/**
 * class Mesh
 */
class Mesh {
  /**
   * constructor
   */
  constructor () {
    this.meshes = []
    this.materials = []
    this.container = new THREE.Object3D()
  }

  load (modelsPath, materialsData, onProgress = ()=>{}) {
    return new Promise((resolve, reject) => {
      
      let modelsProgress = 0
      let modelsLoaded = 0
      let modelsTotal = 0
      let materialsProgress = 0
      let materialsLoaded = 0
      let materialsTotal = 0
      let meshesComplete = false
      let materialsComplete = false

      const checkProgress = () => {
        onProgress((modelsProgress + materialsProgress) * 0.5, modelsLoaded + materialsLoaded, modelsTotal + materialsTotal)
        if (meshesComplete && materialsComplete) {
          this.loadComplete()
          resolve(this)
        }
      }
      const progressModelsHandler = (progress, loaded, total) => {
        modelsProgress = progress
        modelsLoaded = loaded
        modelsTotal = total
        checkProgress()
      }
      const progressMaterialsHandler = (progress, loaded, total) => {
        materialsProgress = progress
        materialsLoaded = loaded
        materialsTotal = total
        checkProgress()
      }

      loadMeshes(modelsPath, progressModelsHandler)
        .then(meshes => {
          this.meshes = this.meshes.concat(meshes)
          this.meshes.map( mesh => {
            this.container.add(mesh)
            // console.log(mesh.material.reduce((str, mat) => str + (' ' + mat.name), ''))
            return mesh
          })
          meshesComplete = true
          modelsProgress = 1
          modelsLoaded = modelsTotal
          checkProgress()
        })
        .catch(error=>reject(error))

      loadTexturedMaterials(Array.from(materialsData, mat => mat.map), progressMaterialsHandler)
        .then(materials => {
          materials.map( (mat, id) => {
            mat.name = materialsData[id] ? materialsData[id].name : mat.name
            return mat
          })
          this.materials = this.materials.concat(materials)
          materialsComplete = true
          materialsProgress = 1
          materialsLoaded = materialsTotal
          checkProgress()
        })
        .catch(error=>reject(error))
    })
  }

  loadComplete () {
    // override me
  }

  addTo (parent, onAdd=()=>{}) {
    this.meshes.map(mesh => {
      onAdd(mesh)
      return mesh
    })
    parent.add(this.container)
  }

  removeFrom (parent, onRemove=()=>{}) {
    this.meshes.map(mesh => {
      onRemove(mesh)
      return mesh
    })
    parent.remove(this.container)
  }
}
export default Mesh


// WEBPACK FOOTER //
// ./src/scripts/webgl/Mesh.js